import GLightbox from 'glightbox'

export function lightbox() {
	GLightbox({
		loop: true,
		touchNavigation: true,
		slideEffect: 'fade',
		autoplayVideos: true,
		videosWidth: '1440px'
	})
}